import axios, { AxiosResponse } from 'axios';
import { api } from '../../../v2.snapshot/js/jcs';

export function resetPasswordRequest(email: string): Promise<AxiosResponse<void>> {
  const url = `${api.url_v3}/resetpassword/request`;
  return axios.post(url, { email });
}
